import React, { useState } from 'react';
import SalesInventory from './SalesInventory';
import SalesInventoryCommision from './SalesInventoryCommision';

const SaleInventoryMain = () => {
    const [activeTab, setActiveTab] = useState('direct');

    return (
        <div style={styles.mainWrapper}>
            {/* TABS SECTION - Ab ye scroll ho kar ooper chala jaye ga */}
            <div style={styles.tabContainer}>
                <div style={styles.pillBox}>
                    <button 
                        onClick={() => setActiveTab('direct')} 
                        style={activeTab === 'direct' ? styles.activePill : styles.pill}
                    >
                        📦 Direct Sales
                    </button>
                    <button 
                        onClick={() => setActiveTab('commission')} 
                        style={activeTab === 'commission' ? styles.activePill : styles.pill}
                    >
                        🤝 Commission
                    </button>
                </div>
            </div>

            <div style={styles.contentArea}>
                {activeTab === 'direct' ? <SalesInventory /> : <SalesInventoryCommision />}
            </div>
        </div>
    );
};

const styles = {
    mainWrapper: { width: '100%', display: 'flex', flexDirection: 'column' },
    tabContainer: {
        backgroundColor: '#fff',
        padding: '12px 0',
        borderBottom: '1px solid #e2e8f0',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '15px'
    },
    pillBox: { display: 'flex', background: '#f1f5f9', padding: '4px', borderRadius: '12px' },
    pill: { padding: '8px 20px', border: 'none', background: 'transparent', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', color: '#64748b', fontSize: '13px', transition: '0.3s' },
    activePill: { padding: '8px 20px', border: 'none', background: '#fff', color: '#2563eb', borderRadius: '8px', fontWeight: 'bold', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' },
    contentArea: { padding: '0 5px' }
};

export default SaleInventoryMain;